import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Stack,
  Text,
  Progress,
  Flex,
  Spinner,
} from '@chakra-ui/react';

const EnvioInformeProgressModal = ({ isOpen, onClose, progress, onRetry, canRetry }) => {
  const stage = progress?.stage || 'Preparando envío...';
  const percent = typeof progress?.percent === 'number' ? progress.percent : null;
  const done = progress?.done || 0;
  const total = progress?.total || 0;
  const showPercent = percent !== null && !Number.isNaN(percent);
  const displayPercent = showPercent ? Math.min(100, Math.max(0, percent)) : null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay bg="blackAlpha.600" />
      <ModalContent>
        <ModalHeader>Enviando informe</ModalHeader>
        <ModalBody>
          <Stack spacing={4}>
            <Flex align="center" gap={3}>
              <Spinner thickness="3px" />
              <Text fontWeight="semibold">{stage}</Text>
            </Flex>
            <Progress
              value={displayPercent ?? undefined}
              isIndeterminate={!showPercent}
              size="sm"
              colorScheme="blue"
              borderRadius="full"
            />
            <Text fontSize="sm" color="gray.600">
              {total > 0 ? `${done}/${total} destinatarios procesados` : 'Preparando destinatarios...'}
            </Text>
            <Text fontSize="xs" color="gray.500">
              Podés cerrar este modal: el envío continúa en segundo plano.
            </Text>
          </Stack>
        </ModalBody>
        <ModalFooter gap={3} flexWrap="wrap">
          {canRetry && typeof onRetry === 'function' && (
            <Button onClick={onRetry} colorScheme="blue" variant="solid">
              Reintentar consulta
            </Button>
          )}
          <Button variant="outline" onClick={onClose}>
            Cerrar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EnvioInformeProgressModal;
